import React from 'react'
import './Header.css'
import SearchIcon from '@material-ui/icons/Search';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import {Link} from "react-router-dom";
import {auth} from "./firebase";
import {useStateValue} from "./StateProvider";
function Header() {
    const [{basket,user},dispatch] = useStateValue();
    const handleAuthentication = () =>{
        if(user){
            auth.signOut();
        }
    }
    return (
        <div className="header">
            {/* Clickable amazon icon, direct to home */}
            <Link to="/"><img className="header_logo" src="http://pngimg.com/uploads/amazon/amazon_PNG11.png" alt=""/></Link>
            
            <div className="header_search">
                <input className="header_searchinput" type="text"></input>
                <SearchIcon className="header_searchicon"></SearchIcon>
            </div>

            <div className="header_nav">
              <Link to= {!user && '/login'}>
                <div onClick= {handleAuthentication} className="header_nav_option">
                    <span className="header_nav_optionline1">Hello {user?user?.email:'Guest'}</span>
                    <span className="header_nav_optionline2">{user?'Sign Out':'Sign In'}</span>
                </div>    
              </Link>
                
                <div className="header_nav_option">
                    <span className="header_nav_optionline1">Returns</span>
                    <span className="header_nav_optionline2">& Orders</span>
                </div>    
                
                <div className="header_nav_option">
                    <span className="header_nav_optionline1">Your</span>
                    <span className="header_nav_optionline2">Prime</span>
                </div>

                <Link to="/checkout">
                    <div className="header_option_basket">
                        <ShoppingBasketIcon></ShoppingBasketIcon>
                        <span className="header_nav_optionline2 header_basketCount">{basket?.length}</span>
                    </div>    
                </Link>
            </div>
        </div>
    )
}

export default Header
